import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/css/reset.css'
import '@/assets/css/common.css'
// 密码加密
import md5 from 'md5'
// 轮播插件
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper)

//element ui
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

// vant ui
import Vant from 'vant'
import 'vant/lib/index.css'
Vue.use(Vant)

Vue.use(require('vue-wechat-title'))

Vue.prototype.$md5 = md5
Vue.config.productionTip = false
      

// 手机控制台插件。打包上线记得注释掉再打包

// import VConsole from 'vconsole'

// const vConsole = new VConsole()

// console.log(vConsole.version)

// 手机端调试工具

// 根据路由判断是否展示bottom组件
router.beforeEach((to, from, next) => {
	// 登录页和H5不显示
	if (to.path.indexOf('login') !== -1 || to.path === '/' || to.path.indexOf('h5') !== -1) {
		store.commit('setShowBottom', false)
	} else {
		store.commit('setShowBottom', true)
	}
	next()
})

/**
 * @description
 * @author (Set the text for this tag by adding docthis.authorName to your settings file.)
 * @date 2019-05-29
 * @param { number } type 1 localStorage 2 sessionStorage
 * @param { string } key 键
 * @param { string } data 要存储的数据
 * @returns
 */
Vue.prototype.$addStorageEvent = function(type, key, data) {
	if (type === 1) {
		// 创建一个StorageEvent事件
		let newStorageEvent = document.createEvent('StorageEvent')
		const storage = {
			setItem: function(k, val) {
				localStorage.setItem(k, val)
				// 初始化创建的事件
				newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null)
				// 派发对象
				window.dispatchEvent(newStorageEvent)
			}
		}
		return storage.setItem(key, data)
	} else {
		// 创建一个StorageEvent事件
		let newStorageEvent = document.createEvent('StorageEvent')
		const storage = {
			setItem: function(k, val) {
				sessionStorage.setItem(k, val)
				// 初始化创建的事件
				newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null)
				// 派发对象
				window.dispatchEvent(newStorageEvent)
			}
		}
		return storage.setItem(key, data)
	}
}

let VueInstance = new Vue({
	router,
	store,
	render: (h) => h(App)
}).$mount('#app')

export default VueInstance
